import React, { useContext, useState } from "react";
import CartContext from "../context/CartContext";
import { MdAddShoppingCart } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import DeliveryInfoModal from "./DeliveryInfoModal";
import {
  openWhatsAppOrder,
  PRODUCT_LIST_WHATSAPP_PHONE,
} from "../utils/whatsappOrder";

function AllProduct({ items }) {
  const { prod, setProd } = useContext(CartContext);
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currency, setCurrency] = useState("₦");

  const handleOrder = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const handleSubmitOrder = async (deliveryInfo) => {
    if (!selectedProduct) return;
    openWhatsAppOrder(
      selectedProduct,
      deliveryInfo,
      PRODUCT_LIST_WHATSAPP_PHONE,
    );
  };

  return (
    <>
      <DeliveryInfoModal
        product={selectedProduct}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleSubmitOrder}
      />
      <div className="product">
        {items?.products?.map((value, i) => {
          return (
            <div key={i}>
              <section onClick={() => navigate(`/single/${value?._id}`)}>
                <img src={value?.images?.[0]} alt="product" loading="lazy" />
              </section>
              <article>
                <p>{value?.name}</p>
                <h2>
                  <small>{currency}</small>
                  {value?.price}.0
                </h2>
                <button onClick={() => handleOrder(value)}>
                  {/*<MdAddShoppingCart />*/} Place Order
                </button>
              </article>
            </div>
          );
        })}
        <br />
        <br />
        <br />
      </div>
    </>
  );
}

export default AllProduct;
